import { FC } from 'react';
import { GoogleLogin } from 'react-google-login';
import axios from 'axios';
import getConfig from 'next/config';
import { useToastNotification } from 'lib/hooks';
import { useRouter } from 'next/router';
import { userClient } from 'lib/clients';

const { publicRuntimeConfig: { genericRESTUrl, googleClientId } } = getConfig();

type Props = {
  onSuccess: Function;
  label?: string;
}

export const Identities: FC<Props> = ({ onSuccess, label }) => {
  const { errorToast } = useToastNotification()
  const { push } = useRouter();

  const googleSuccess = async (res: any) => {
    try {
      await axios.post(`${genericRESTUrl}/v1/google/sign-in`, { token: res.tokenId }, { withCredentials: true });
      const { data } = await userClient.getUser();

      onSuccess(data);
    }
    catch(err) {
      if (err?.response?.status === 306) {
        return push(err.response.data.location);
      }

      googleFailure();
    }
  }

  const googleFailure = () => {
    errorToast({ title: 'Log in', description: 'Failed to sign in with Google' });
  }

  return (
    <GoogleLogin
      clientId={googleClientId}
      buttonText={label || 'Sign in with Google'}
      onSuccess={googleSuccess}
      onFailure={googleFailure}
      cookiePolicy={'single_host_origin'}
      className="google-sign-in"
    />
  );
}